import { useEffect } from 'react';
import ArrowSolid from 'assets/icons/ArrowSolid';
import { Stack, useMediaQuery, Button } from '@mui/material';

const NextPrevButton = ({
	type,
	dataList,
	editItem,
	pagination,
	setEditItem,
	processCode,
	setPagination,
	keyValue = 'id',
	setIsLoading = () => {},
}) => {
	const matchDownSM = useMediaQuery((theme) => theme.breakpoints.down('sm'));

	const onPreHandler = () => {
		if (pagination.currentPage > 0) {
			const prevPageIndex = pagination.currentPage - 1;

			if (prevPageIndex > -1 && pagination.lastPage) {
				setEditItem({ processCode, ...dataList[prevPageIndex] });
				setIsLoading((prev) => !prev);
			} else {
				setEditItem(null);
			}

			setPagination((prev) => ({
				...prev,
				currentPage: prevPageIndex,
			}));
		}
	};

	const onNextHandler = () => {
		if (pagination.currentPage < pagination.lastPage) {
			const nextPageIndex = pagination?.currentPage + 1;

			if (nextPageIndex > -1 && pagination.lastPage) {
				setEditItem({ processCode, ...dataList[nextPageIndex] });
				setIsLoading((prev) => !prev);
			} else {
				setEditItem(null);
			}

			setPagination((prev) => ({
				...prev,
				currentPage: nextPageIndex,
			}));
		}
	};

	useEffect(() => {
		if (dataList?.length > 0 && editItem) {
			const currentItemIndex = dataList?.findIndex((item) => item.id === editItem?.[keyValue]);

			setPagination({
				firstPage: 0,
				currentPage: currentItemIndex,
				lastPage: dataList?.length - 1,
			});
		}
	}, []);

	return (
		!matchDownSM && (
			<Stack direction="row" justifyContent="right" sx={{ gap: '8px' }}>
				<Button
					onClick={onPreHandler}
					disabled={type === 'Edit' ? true : pagination?.currentPage < 1}
					sx={{
						height: '36px',
						padding: '7px 8px',
						color: '#155DFC',
						borderRadius: '10px',
						border: '1px solid #155DFC',

						'&:disabled': {
							border: '1px solid #d9d9d9',
						},
					}}
				>
					{/* <CaretLeftOutlined /> */}
					<ArrowSolid
						width="16px"
						height="16px"
						color={type === 'Edit' ? '#d9d9d9' : pagination?.currentPage < 1 ? '#d9d9d9' : '#155DFC'}
					/>
				</Button>

				<Button
					onClick={onNextHandler}
					sx={{
						height: '36px',
						padding: '7px 8px',
						color: '#155DFC',
						borderRadius: '10px',
						border: '1px solid #155DFC',

						'&:disabled': {
							border: '1px solid #d9d9d9',
						},
					}}
					disabled={type === 'Edit' ? true : pagination?.currentPage >= pagination?.lastPage}
				>
					{/* <CaretRightOutlined /> */}

					<ArrowSolid
						width="16px"
						height="16px"
						style={{ transform: 'rotate(180deg)' }}
						color={type === 'Edit' ? '#d9d9d9' : pagination?.currentPage >= pagination?.lastPage ? '#d9d9d9' : '#155DFC'}
					/>
				</Button>
			</Stack>
		)
	);
};

export default NextPrevButton;
